import { createRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "@/hooks/useSafeTranslation";
import { rootRoute } from "./__root";
import { getToken } from "@/auth";
import { LoginForm } from "@/components/LoginForm";
import { toDisplayString, toSafeReactNode } from "@/lib/utils";

function LoginPage() {
  const { t } = useTranslation("common");
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg p-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 flex flex-col items-center justify-center gap-3 px-4 py-3 w-full">
          <img src="/icon.svg" alt="" width={64} height={64} className="shrink-0" />
          <img src="/wordmark.svg" alt={toDisplayString(t("login.title"))} className="h-14 w-auto block mx-auto" />
        </div>
        <div className="rounded-xl border border-border bg-surface-2 p-8 shadow-md">
          <p className="mb-4 text-center text-sm text-text-muted">
            {toSafeReactNode(t("login.subtitle"))}
          </p>
          <LoginForm />
        </div>
      </div>
    </div>
  );
}

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  validateSearch: (s: Record<string, unknown>) => ({
    extensionAuth: typeof s?.extensionAuth === "string" ? s.extensionAuth : undefined,
    redirect: typeof s?.redirect === "string" ? s.redirect : undefined,
    from: typeof s?.from === "string" ? s.from : undefined,
  }),
  beforeLoad: async () => {
    const token = await getToken();
    if (token) {
      const params =
        typeof window !== "undefined"
          ? new URLSearchParams(window.location.search)
          : null;
      const extensionAuth = params?.get("extensionAuth");
      const redirectParam = params?.get("redirect");
      const search =
        extensionAuth && redirectParam
          ? { extensionAuth, redirect: redirectParam }
          : undefined;
      throw redirect({ to: "/", search });
    }
  },
  component: LoginPage,
});
